import { userConstants } from '../constants';
import { userService } from '../services';

import { history } from '../helpers';

const register = (user) => {
  const request = (user) => ({ type: userConstants.REGISTER_REQUEST, user });
  const success = (user) => ({ type: userConstants.REGISTER_SUCCESS, user });
  const failure = (error) => ({ type: userConstants.REGISTER_FAILURE, error });
  const setUser = (user) => ({ type: userConstants.SET_USER, user });

  return dispatch => {
    dispatch(request(user));
    userService.register(user)
      .then(res => {
        const { data: token, courseCode, message } = res.data;
        if (!!token) {
          const user = { token, courseCode };
          localStorage.setItem('currentUser', JSON.stringify(user));
          dispatch(success(user))
          dispatch(setUser(user));
          history.replace("/");
        }
        else {
          dispatch(failure({
            message 
          }));
        }
      })
      .catch(err => {
        dispatch(failure(err));
      });
  }
}

const checkRegistration = (user) => {
  const request = (user) => ({ type: userConstants.CHECK_REGISTRATION_REQUEST, user });
  const success = (registered) => ({ type: userConstants.CHECK_REGISTRATION_SUCCESS, registered });
  const failure = (error) => ({ type: userConstants.CHECK_REGISTRATION_FAILURE, error });

  return dispatch => {
    dispatch(request(user));
    userService.checkRegistration(user)
      .then(res => {
        const { data: registered } = res.data;
        dispatch(success(registered));
      })
      .catch(err => {
        dispatch(failure(err));
      });
  }
}

const sendPasswordReset = (email) => {
  const request = (email) => ({ type: userConstants.SEND_PASSWORD_RESET_REQUEST, email });
  const success = () => ({ type: userConstants.SEND_PASSWORD_RESET_SUCCESS });
  const failure = (error) => ({ type: userConstants.SEND_PASSWORD_RESET_FAILURE, error });

  return dispatch => {
    dispatch(request(email));
    userService.sendPasswordReset(email)
      .then(res => {
        const { data } = res.data;
        dispatch(success());
      })
      .catch(err => {
        dispatch(failure(err));
      });
  }
}

const resetPassword = (user) => {
  const request = () => ({ type: userConstants.PASSWORD_RESET_REQUEST });
  const success = () => ({ type: userConstants.PASSWORD_RESET_SUCCESS });
  const failure = (error) => ({ type: userConstants.PASSWORD_RESET_FAILURE, error });

  return dispatch => {
    dispatch(request());
    userService.resetPassword(user)
      .then(res => {
        const { successful, message } = res.data;
        if (successful) {
          dispatch(success());
          history.replace("/resetmessage");
        }
        else {
          dispatch(failure({
            message
          }));
        }
      })
      .catch(err => {
        dispatch(failure(err));
      });
  }
}

export const userActions = {
  checkRegistration,
  register,
  sendPasswordReset,
  resetPassword
}
